import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var ReportStatus;
(function (ReportStatus) {
    // CLICK = 'CLICK',
    ReportStatus["LEAD"] = "LEAD";
    ReportStatus["FTD"] = "FTD";
    ReportStatus["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    ReportStatus["REGISTRATION_FAILED"] = "REGISTRATION_FAILED";
    ReportStatus["ACCEPTED"] = "ACCEPTED";
    ReportStatus["DUPLICATE"] = "DUPLICATE";
})(ReportStatus || (ReportStatus = {}));
export const ReportStatusMap = new Map([
    // [ReportStatus.CLICK, 'Global.Options.Click'],
    [ReportStatus.LEAD, 'Global.Options.Lead'],
    [ReportStatus.FTD, 'Global.Options.FTD'],
    [ReportStatus.VALIDATION_FAILED, 'Global.Options.ValidationFailed'],
    [ReportStatus.REGISTRATION_FAILED, 'Global.Options.RegistrationFailed'],
    [ReportStatus.ACCEPTED, 'Global.Options.ReportStatus.ACCEPTED'],
    [ReportStatus.DUPLICATE, 'Global.Options.ReportStatus.DUPLICATE'],
]);
let ReportStatusService = class ReportStatusService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = ReportStatusMap;
    }
    list() {
        return this._data;
    }
    get(status) {
        const s = this._data.get(status);
        return s ? this._translate.instant(s) : s;
    }
};
ReportStatusService.ctorParameters = () => [
    { type: TranslateService }
];
ReportStatusService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], ReportStatusService);
export { ReportStatusService };
